import { useState } from 'react';

interface FAQProps {
  faqQuestions: string[];
  faqAnswers: string[];
}

const FAQComponent = ({ faqQuestions, faqAnswers }: FAQProps) => {
  const [expandedIndexes, setExpandedIndexes] = useState<boolean[]>(faqQuestions.map(() => false));

  const toggleExpand = (index: number) => {
    const newExpandedIndexes = [...expandedIndexes];
    newExpandedIndexes[index] = !newExpandedIndexes[index];
    setExpandedIndexes(newExpandedIndexes);
  };

  return (
    <div className='mt-8 px-4 md:px-0'>
      <h2 className='text-2xl font-semibold mb-4'>FAQ's</h2>
      {faqQuestions.map((question, index) => (
        <div key={index} className='mb-4'>
          <div
            className={`cursor-pointer py-4 px-4 bg-white rounded-lg shadow-sm border border-light hover:shadow-md transition-shadow ${expandedIndexes[index] ? 'pb-8' : ''
              }`}
            onClick={() => toggleExpand(index)}
          >
            <div className='flex justify-between items-center'>
              <h3 className='text-base md:text-lg font-medium w-[90%]'>{question}</h3>
              <svg
                className={`w-8 h-8 transition-transform duration-300 p-1 rounded-full text-halo-pink hover:bg-halo-pink hover:text-white focus:outline-none ${expandedIndexes[index] ? 'rotate-180' : ''
                  }`}
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M19 9l-7 7-7-7'
                />
              </svg>
            </div>
            {expandedIndexes[index] && (
              <p className='mt-3 text-gray-700' dangerouslySetInnerHTML={{ __html: faqAnswers[index] }}></p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQComponent;
